@if (metadata) {
<div class="filter-section">
  <div class="filter-section-header">
    <mat-icon>category</mat-icon>
    <span>Type</span>
  </div>
  <div class="filter-chip-row filter-chip-row--wrap">
    @for (slug of ['education', 'exercise', 'course', 'activity']; track slug) {
    @if (slug !== 'exercise' || metadata.visibility?.showExercises) {
    <div
      class="fchip"
      [class.active]="isEventTypeOn(slug)"
      (click)="toggleEventType(slug)"
    >
      <span>{{ eventTypeLabels[slug] || slug }}</span>
    </div>
    }
    }
  </div>
</div>

<div class="toggle-row">
  <mat-checkbox
    [ngModel]="filters['hideSubEvents'] !== false"
    (ngModelChange)="patch({ hideSubEvents: $event })"
  >
    Skjul underbegivenheder
  </mat-checkbox>
  @if (metadata.visibility?.showHideFull) {
  <mat-checkbox
    [ngModel]="!!filters['hideFullEvents']"
    (ngModelChange)="patch({ hideFullEvents: $event })"
  >
    Skjul fyldte
  </mat-checkbox>
  }
  @if (metadata.visibility?.showHideParticipated) {
  <mat-checkbox
    [ngModel]="!!filters['hideParticipatedEvents']"
    (ngModelChange)="patch({ hideParticipatedEvents: $event })"
  >
    Skjul mine deltagelser
  </mat-checkbox>
  }
  @if (showGroupCalendarFilter) {
  <mat-checkbox
    [ngModel]="!!filters['showGroupCalendarEvents']"
    (ngModelChange)="patch({ showGroupCalendarEvents: $event })"
  >
    Vis gruppekalender-begivenheder
  </mat-checkbox>
  }
</div>

@if (showOrganizationFilter) {
<div class="filter-section">
  <label class="panel-label">Organisation</label>
  <app-filter-multi-select
    [displayText]="formatOrgs()"
    [options]="orgOptions()"
    [selectedValues]="organizationIds"
    (selectedValuesChange)="onOrgChange($event)"
  />
</div>
}

@if (metadata.visibility?.showEducationalPaths) {
<div class="filter-section">
  <label class="panel-label">Uddannelsesveje</label>
  <app-filter-multi-select
    [displayText]="formatPaths()"
    [options]="pathOptions()"
    [selectedValues]="educationalPathIds"
    (selectedValuesChange)="onPathsChange($event)"
  />
</div>
}

@if (metadata.visibility?.showModules) {
<div class="filter-section">
  <label class="panel-label">Moduler</label>
  <app-filter-multi-select
    [displayText]="formatModules()"
    [options]="moduleOptions()"
    [selectedValues]="moduleIds"
    (selectedValuesChange)="onModulesChange($event)"
  />
</div>
}

@if (metadata.visibility?.showLocations) {
<div class="filter-section">
  <label class="panel-label">Lokation</label>
  <app-filter-multi-select
    [displayText]="formatLocations()"
    [options]="locationOptions()"
    [selectedValues]="locationGuids"
    (selectedValuesChange)="onLocationsChange($event)"
  />
</div>
}
} @else {
<p>Indlæser filter…</p>
}
